
    <div class="form-group">
      <label for="inputIdentifier">请填写内容标识符</label>
      <input [(ngModel)]="block.data.identifier" type="text" class="form-control" id="inputIdentifier"
             placeholder="Identifier">
    </div>
  